module.exports = __webpack_public_path__ + "static/media/contact-bg.0e38f139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact-bg.jpg
// module id = 240
// module chunks = 0